export function unknownCommand(option: string): void {
  console.log(`error: unknown option '${option}'`);
}
